import React from 'react';

import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import {styled} from '@mui/material/styles';
import {Author} from "~/components/article-media-card/components/Author";


const StyledCard = styled(Card)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
        backgroundColor: 'transparent',
        cursor: 'pointer',
    },
    '&:focus-visible': {
        outline: '3px solid',
        outlineColor: 'hsla(210, 98%, 48%, 0.5)',
        outlineOffset: '2px',
    },
}));

const StyledCardContent = styled(CardContent)({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: 16,
    flexGrow: 1,
    '&:last-child': {
        paddingBottom: 16,
    },
});

const StyledTypography = styled(Typography)({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});


interface ArticleMediaCardProps {
    index?: number;
    article: {
        img: string;
        tag: string;
        title: string;
        description: string;
        authors: { name: string, avatar: string }[]
    };
    handleFocus: (index: number) => void;
    handleBlur: () => void;
    focusedCardIndex: number | null;
}

export function ArticleMediaCard({article, handleFocus, handleBlur, focusedCardIndex}: ArticleMediaCardProps) {
    return (
        <StyledCard
            variant="outlined"
            onFocus={() => handleFocus(0)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 0 ? 'Mui-focused' : ''}
        >
            <CardMedia
                component="img"
                alt="green iguana"
                image={article.img}
                sx={{
                    aspectRatio: '16 / 9',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            />
            <StyledCardContent>
                <Typography gutterBottom variant="caption" component="div">
                    {article.tag}
                </Typography>
                <Typography gutterBottom variant="h6" component="div">
                    {article.title}
                </Typography>
                <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                    {article.description}
                </StyledTypography>
            </StyledCardContent>
            <Author authors={article.authors}/>
        </StyledCard>
    )
}